<template>
  <div>
    <div class="member-wrap" v-if="isMember" :class="namespaceGroup">
      <div class="header-wrap">
        <div class="card-message">
          <div>到期时间：{{ card.card_expiry_date }}</div>
        </div>
      </div>
      <div class="content-wrap">
        <template v-if="!loading">
          <component
            :is="item.display_code"
            v-for="item of categoryList"
            :card="card"
            :key="item.id"
            :item="item"
            :type="item.display_code"
            :namespace="namespace"
            v-show="handleShowComponent(item)"
          />
          <div class="action-wrap">
            <div class="order" @click="handleToOrder">
              <svg-icon :iconClass="'bj-service-by'" />我的订单
            </div>
            <div class="line"></div>
            <div class="service" @click="handleToService">
              <svg-icon :iconClass="'bj-order-by'" />客服中心
            </div>
          </div>
        </template>
      </div>
    </div>
    <van-empty
      v-else-if="!isMember"
      class="member-wrap"
      description="您还不是会员，请开通会员后使用"
    />
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";
import Vue from "vue";

import { useStore, useRouter } from "@/components/use/base";

import WxjkHeader from "@/views/index/moreCard/visitor/component/wxjk/WxjkHeader.vue";
import HbHeader from "@/views/index/moreCard/visitor/component/common/HbHeader.vue";
import HbBenefit from "@/views/index/moreCard/visitor/component/common/HbBenefit.vue";
import useMoreCard from "@/use/useMoreCard";

import Header from "../component/header.vue";
import Tab from "../component/Tab.vue";
import benefit from "../component/benefit.vue";
import BjHeader from "../component/header.vue";
import benefitMore from "../component/benefitMore.vue";
import SaveMoneyHeader from "../component/SaveMoneyHeader.vue";
import BenefitVisitor from "../component/BenefitVisitor.vue";
import JxmBenefit from "../component/JxmBenefit.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    BjHeader,
    benefit,
    benefitMore,
    SaveMoneyHeader,
    BenefitVisitor,
    Tab,
    WxjkHeader,
    HbHeader,
    HbBenefit,
    Header,
    JxmBenefit,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const { initMoreCard, getCardList, card, categoryList, currentCard } =
      useMoreCard();

    const loading = ref(true);

    const namespace = computed(() => store.state.namespace);
    const isMember = computed(() => store.state.isMember);
    const namespaceGroup = computed(() => {
      if (/^\d/.test(store.state.namespaceInfo.namespace_group_en))
        return `xshk-${store.state.namespaceInfo.namespace_group_en}`;
      return store.state.namespaceInfo.namespace_group_en;
    });

    // 如果不是合法权益就不展示楼层
    const handleShowComponent = computed(() => (item) => {
      if (item.display_code === "HbHeader") {
        return true;
      }
      const productInfo = item.productInfo;
      const benefitList = card.value.benefit_list.map((item) => item.type);
      let show = true;
      productInfo.forEach((element) => {
        if (!benefitList.includes(element.benefit_type)) show = false;
      });
      return show;
    });

    onMounted(async () => {
      const loadingPage = vm.$loading();
      loading.value = true;
      try {
        await getCardList();
        await initMoreCard();
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
        loadingPage.clear();
      }
    });

    const handleToOrder = () => {
      router.push("/order");
    };

    const handleToService = () => {
      router.push("/help");
    };

    return {
      categoryList,
      card,
      currentCard,
      loading,
      namespace,
      isMember,
      handleShowComponent,
      namespaceGroup,
      handleToOrder,
      handleToService,
    };
  },
});
</script>

<style lang="less" scoped>
.member-wrap {
  overflow: hidden;
  background: linear-gradient(270deg, #f7f1db 0%, #ffffff 50.68%, #cae0fe 100%);
}

.header-wrap {
  width: 375px;
  height: 168px;
  background-image: url("https://common-h5-dev.xiangshuheika.com/static/upload/2026626ca3b8eb24c04aa4ba503e4ab04d2759.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

  .card-message {
    position: absolute;
    left: 32px;
    top: 111px;
    font-weight: 400;
    font-size: 12px;
    color: #fcf4e4;
  }
}

.content-wrap {
  overflow: hidden;
  min-height: calc(100vh - 168px);
  background: linear-gradient(180deg, #fcfbf4 0%, #f4f6f9 100%);
  border-radius: 16px 16px 0 0;
}

.action-wrap {
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 31px;

  display: flex;
  align-items: center;
  width: 343px;
  height: 32px;
  background: #ffffff;
  border-radius: 8px;
  box-sizing: border-box;

  font-weight: 400;
  font-size: 15px;
  color: #333333;

  svg {
    height: 20px;
    width: 22px;
    margin-right: 9px;
  }

  .order {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .line {
    width: 1px;
    height: 23px;
    background: #e4e4e4;
  }

  .service {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
}
</style>
